"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormGroup = _interopRequireDefault(require("./FormGroup"));

var _reactFlatpickr = _interopRequireDefault(require("react-flatpickr"));

require("flatpickr/dist/themes/material_blue.css");

require("./FormDatepickerFlatpickrInput.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var FormDatepickerFlatpickrInput = /*#__PURE__*/function (_React$Component) {
  _inherits(FormDatepickerFlatpickrInput, _React$Component);

  var _super = _createSuper(FormDatepickerFlatpickrInput);

  function FormDatepickerFlatpickrInput(props) {
    var _this;

    _classCallCheck(this, FormDatepickerFlatpickrInput);

    _this = _super.call(this, props);
    _this.state = {
      completedOnDate: _this.props.completedOnDate
    };
    return _this;
  }

  _createClass(FormDatepickerFlatpickrInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var handleOnChange = function handleOnChange(date) {
        var selectedDate = null;
        var userInputIsPresent = date !== undefined && Array.isArray(date) && date.length > 0;

        if (userInputIsPresent) {
          selectedDate = date[0];
        }

        _this2.setState({
          completedOnDate: selectedDate
        });

        var changedDateEvent = {
          "target": {
            "value": selectedDate,
            "name": _this2.props.name
          }
        };

        _this2.props.onChange(changedDateEvent);
      };

      var minDate = this.props.minDate ? this.props.minDate : "2019-01-01";
      var maxDate = this.props.maxDate ? this.props.maxDate : null;
      return /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
        hasError: !!this.props.errorMessage,
        filled: !!this.state.completedOnDate
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "bmd-label-floating",
        htmlFor: this.props.name
      }, this.props.errorMessage || this.props.label), /*#__PURE__*/_react["default"].createElement(_reactFlatpickr["default"], {
        value: this.state.completedOnDate,
        name: this.props.name,
        id: this.props.name,
        type: "input",
        className: "form-control",
        onChange: handleOnChange,
        onClose: this.props.onBlur,
        options: {
          minDate: minDate,
          maxDate: maxDate,
          dateFormat: "m/d/y",
          disableMobile: "true"
        },
        style: {
          backgroundColor: "#ffffff"
        }
      }));
    }
  }]);

  return FormDatepickerFlatpickrInput;
}(_react["default"].Component);

var _default = FormDatepickerFlatpickrInput;
exports["default"] = _default;